// Map internal tool names to user-friendly labels.
// Users should see "TrueHacking AI" — not Ollama, qwen, nuclei, etc.

const TOOL_LABELS: Record<string, string> = {
  // Recon
  subfinder: "Subdomain Discovery",
  amass: "Domain Enumeration",
  dnsx: "DNS Resolution",
  dnstwist: "Domain Permutation",
  theharvester: "OSINT Harvesting",
  gitleaks: "Secret Detection",
  trufflehog: "Secret Scanning",
  h8mail: "Credential Lookup",
  s3scanner: "Cloud Storage Scan",
  // Discovery
  httpx: "HTTP Probing",
  naabu: "Port Scanning",
  nmap: "Network Scanning",
  // Fingerprinting
  whatweb: "Technology Detection",
  wafw00f: "WAF Detection",
  testssl: "TLS Analysis",
  // Crawling
  katana: "Web Crawling",
  ffuf: "Content Discovery",
  gobuster: "Directory Fuzzing",
  // Vuln scanning
  nuclei: "Vulnerability Scan",
  nikto: "Web Server Scan",
  zap: "Security Proxy Scan",
  // Deep validation
  sqlmap: "SQL Injection Test",
  // AI
  ollama: "TrueHacking AI",
  "qwen2.5-coder": "TrueHacking AI",
  "qwen2.5-coder:14b": "TrueHacking AI",
};

export function friendlyToolName(raw: string): string {
  const lower = raw.toLowerCase();
  return TOOL_LABELS[lower] ?? TOOL_LABELS[raw] ?? raw;
}
